import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { ThemeProvider } from "@/contexts/ThemeContext";
import { ReadsProvider } from "@/contexts/ReadsContext";
import { Toaster } from "@/components/ui/sonner";
import ErrorBoundary from "@/components/ErrorBoundary";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import BlogReader from "@/pages/BlogReader";
import SearchPage from "@/pages/SearchPage";
import { PathwaysList, PathwayView } from "@/pages/Pathways";
import Bookmarks from "@/pages/Bookmarks";
import Admin from "@/pages/Admin";
import AuthCallback from "@/pages/AuthCallback";
import Login from "@/pages/Login";
import VerifyEmail from "@/pages/VerifyEmail";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import TipThankYou from "@/pages/TipThankYou";
import TipCancel from "@/pages/TipCancel";
import Glossary from "@/pages/Glossary";
import Profile from "@/pages/Profile";
import AuthorPage from "@/pages/AuthorPage";
import ToolsAndMetrics from "@/pages/ToolsAndMetrics";

function AppRouter() {
  const location = useLocation();
  // Handle session_id in hash (from Emergent Auth redirect) synchronously
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/login" element={<Login />} />
        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/tip/thank-you" element={<TipThankYou />} />
        <Route path="/tip/cancel" element={<TipCancel />} />
        <Route path="/blogs/:slug" element={<BlogReader />} />
        <Route path="/search" element={<SearchPage />} />
        <Route path="/pathways" element={<PathwaysList />} />
        <Route path="/pathways/:slug" element={<PathwayView />} />
        <Route path="/bookmarks" element={<Bookmarks />} />
        <Route path="/glossary" element={<Glossary />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/authors/:slug" element={<AuthorPage />} />
        <Route path="/tools-and-metrics" element={<ToolsAndMetrics />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
    </Layout>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ThemeProvider>
          <AuthProvider>
            <ReadsProvider>
              <ErrorBoundary>
                <AppRouter />
              </ErrorBoundary>
              <Toaster position="top-right" richColors />
            </ReadsProvider>
          </AuthProvider>
        </ThemeProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
